import React from 'react';
import i18n from 'i18n-react';

import ContentHeader from 'components/ContentHeader';
import Toolbox from 'components/Toolbox';

const ToolboxView = () => (
  <div className="contentContainer toolbox">
    <div className="backgroundImage" />
    <ContentHeader
      header={i18n.translate('nav.sell')}
      subtitle={i18n.translate('pageDescriptions.sell')}
      social
      line
    />
    <Toolbox />
  </div>
);

export default ToolboxView;
